import Text from '@/components/Text'
import { useMobileView } from '@/hooks'
import React, { useCallback } from 'react'
import { FooterComponent, Icon } from './components'

const Footer: React.FC = () => {
  const isMobile = useMobileView()

  const openBeianLink = useCallback(() => {
    window.open('https://beian.miit.gov.cn/#/Integrated/recordQuery', '_blank')
  }, [])

  return (
    <FooterComponent>
      <Text size="xs" weight="thin" sx={isMobile ? { fontSize: '12px' } : null}>
        Copyright ©2022 北京长亭科技有限公司
      </Text>
      <Text
        size="xs"
        weight="thin"
        sx={{
          display: 'flex',
          alignItems: 'center',
          cursor: 'pointer',
          ...(isMobile ? { fontSize: '12px' } : null),
          '&:hover': {
            textDecoration: 'underline',
          },
        }}
        onClick={openBeianLink}
      >
        <Icon />
        京ICP备 2024055124号-2
      </Text>
    </FooterComponent>
  )
}

export default Footer
